<template>
  <div class="pI_match_block">
    <div
      @click="gotoIndexdetail(gamedata)"
      class="pI_match_info"
      style="cursor: pointer"
      v-bind:class="{ prematch: gamedata.Status != 'InProgress' }"
    >
      <!-- <span class="match_status" v-if="gamedata.Status == 'InProgress'">
        <template>LIVE</template>
      </span> -->
      <div class="live-alert" v-if="gamedata.Status == 'InProgress'">
        <div class="waveWrapper left">
          <div class="waveWrapperInner delay1">
            <div class="wave"></div>
          </div>
          <div class="waveWrapperInner delay2">
            <div class="wave"></div>
          </div>
          <div class="waveWrapperInner delay3">
            <div class="wave"></div>
          </div>
        </div>
        <div class="wave-text">
          <div class="text-wrapper">
            <h2>Live</h2>
          </div>
        </div>
        <div class="waveWrapper right">
            <div class="waveWrapperInner delay1">
              <div class="wave"></div>
            </div>
            <div class="waveWrapperInner delay2">
              <div class="wave"></div>
            </div>
            <div class="waveWrapperInner delay3">
              <div class="wave"></div>
            </div>
        </div>
      </div>
      <div class="PI_match_teams">
        <figcaption>{{ gamedata.HomeTeam.Name }}</figcaption>
        <figure v-if="gamedata.HomeTeam">
          <img :src="gamedata.HomeTeam.logo" />
        </figure>
        <span
          v-if="gamedata.LiveProb"
          >{{ gamedata.LiveProb.home_score}}</span
        >
        <label v-if="gamedata.Status == 'InProgress' && gamedata.LiveProb"
          ><small>SCORES</small><b>{{ elapsedTime }}</b></label
        >
        <label v-else-if="gamedata.Status == 'Scheduled'"
          ><small>Starts In</small><b>{{ startsIn }}</b></label
        >
        <label v-else-if="gamedata.Status != 'InProgress' && gamedata.Status != 'Scheduled'"
          ><small>Status</small><b>{{gamedata.Status}}</b></label
        >

        <span
          v-if="gamedata.LiveProb"
          >{{ gamedata.LiveProb.away_score }}</span
        >
        <figure v-if="gamedata.AwayTeam">
          <img :src="gamedata.AwayTeam.logo" />
        </figure>
        <figcaption>{{ gamedata.AwayTeam.City }}</figcaption>
      </div>
      <div class="PI_team_scores">
        <div class="team1_score">
          <div
            class="score_value"
            v-bind:class="{
              high: HomeWinPer * 100 > 60,
              low: HomeWinPer * 100 < 30,
              medium:
                HomeWinPer * 100 > 30 &&
                HomeWinPer * 100 < 60,
            }"
          >
            <label
              >{{ HomeWinPer | percentagecustom(1)
              }}<sub>%</sub></label
            >
            <span>H</span>
          </div>
          <div
            class="score_progress"
            v-bind:class="{
              high: HomeWinPer * 100 > 60,
              low: HomeWinPer * 100 < 30,
              medium:
                HomeWinPer * 100 > 30 &&
                HomeWinPer * 100 < 60,
            }"
            v-bind:style="{ width: HomeWinPer * 100 + '%' }"
          ></div>
        </div>
        <div class="team2_score">
          <div
            class="score_progress"
            v-bind:class="{
              high: AwayWinPer * 100 > 60,
              low: AwayWinPer * 100 < 30,
              medium:
                AwayWinPer * 100 > 30 &&
                AwayWinPer * 100 < 60,
            }"
            v-bind:style="{ width: AwayWinPer * 100 + '%' }"
          ></div>
          <div
            class="score_value"
            v-bind:class="{
              high: AwayWinPer * 100 > 60,
              low: AwayWinPer * 100 < 30,
              medium:
                AwayWinPer * 100 > 30 &&
                AwayWinPer * 100 < 60,
            }"
          >
            <span>A</span>
            <label
              >{{ AwayWinPer | percentagecustom(1)
              }}<sub>%</sub></label
            >
          </div>
        </div>
        <strong class="trophy"><img src="@/assets/images/trophy.png" /></strong>
      </div>
    </div>
    <div class="PI_match_details" v-if="gamedata.HomeTeam.stats.length > 0">
      <v-tabs class="pro_tabs" dark v-model="tab">
        <v-tab><span>Wins</span></v-tab>
        <v-tab><span>Season Stats </span></v-tab>

        <v-tab-item>
          <div>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <!-- <th>&nbsp;</th> -->
                    <th ></th>
                    <th>This Season</th>
                    <th>Previous Matches</th>
                  </tr>
                </thead>
                <tbody>
                  <template>
                    <tr>
                      <td class="team_logo">
                        <figure class="team_logo">
                          <img width="50" :src="gamedata.HomeTeam.logo" />
                        </figure>
                      </td>
             
                      <td v-if="gamedata.HomeTeam.stats.length > 0">
                        <div class="seassion_matches">
                          <p>
                            <b>{{ gamedata.HomeTeam.stats[0].Wins }}</b
                            ><br />WINS
                          </p>
                          <p>
                            <b>{{ gamedata.HomeTeam.stats[0].Losses }}</b
                            ><br />Losses
                          </p>
                         
                        </div>
                      </td>
                      <td>
                        <div
                          class="Previous_matches"
                          v-if="gamedata.HomeTeam.lastgame && gamedata.HomeTeam.lastgame.AwayTeamID && gamedata.HomeTeam.lastgame.HomeTeamID"
                          v-bind:class="{
                            match1:
                              gamedata.HomeTeam.lastgame.AwayTeamScore >
                              gamedata.HomeTeam.lastgame.HomeTeamScore,
                            match2:
                              gamedata.HomeTeam.lastgame.AwayTeamScore <
                              gamedata.HomeTeam.lastgame.HomeTeamScore,
                          }"
                        >
                          <figure>
                            <img width="50" :src="teamLogoById(gamedata.HomeTeam.lastgame.AwayTeamID)" :alt="'Team ' + gamedata.HomeTeam.lastgame.AwayTeamID" />
                            <figcaption>
                              {{ gamedata.HomeTeam.lastgame.AwayTeamScore }}
                            </figcaption>
                          </figure>
                          <span><img src="@/assets/images/vs.svg" /></span>
                          <figure>
                            <figcaption>
                              {{ gamedata.HomeTeam.lastgame.HomeTeamScore }}
                            </figcaption>
                            <img width="50" :src="teamLogoById(gamedata.HomeTeam.lastgame.HomeTeamID)" :alt="'Team ' + gamedata.HomeTeam.lastgame.HomeTeamID" />
                          </figure>
                        </div>
                        <div v-else class="Previous_matches">
                          <p style="text-align: center; color: #999;">No previous match data</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="team_logo">
                        <figure class="team_logo">
                          <img width="50" :src="gamedata.AwayTeam.logo" />
                        </figure>
                      </td>
                     
                      <td>
                        <div class="seassion_matches">
                          <p>
                            <b>{{ gamedata.AwayTeam.stats[0].Wins }}</b
                            ><br />WINS
                          </p>
                                 <p>
                            <b>{{ gamedata.AwayTeam.stats[0].Losses }}</b
                            ><br />Losses
                          </p>
                  
                        </div>
                      </td>
                      <td>
                        <div
                          class="Previous_matches"
                          v-if="gamedata.AwayTeam.lastgame && gamedata.AwayTeam.lastgame.AwayTeamID && gamedata.AwayTeam.lastgame.HomeTeamID"
                          v-bind:class="{
                            match1:
                              gamedata.AwayTeam.lastgame.AwayTeamScore >
                              gamedata.AwayTeam.lastgame.HomeTeamScore,
                            match2:
                              gamedata.AwayTeam.lastgame.AwayTeamScore <
                              gamedata.AwayTeam.lastgame.HomeTeamScore,
                          }"
                        >
                          <figure>
                            <img width="50" :src="teamLogoById(gamedata.AwayTeam.lastgame.AwayTeamID)" :alt="'Team ' + gamedata.AwayTeam.lastgame.AwayTeamID" />
                            <figcaption>
                              {{ gamedata.AwayTeam.lastgame.AwayTeamScore }}
                            </figcaption>
                          </figure>
                          <span><img src="@/assets/images/vs.svg" /></span>
                          <figure>
                            <figcaption>
                              {{ gamedata.AwayTeam.lastgame.HomeTeamScore }}
                            </figcaption>
                            <img width="50" :src="teamLogoById(gamedata.AwayTeam.lastgame.HomeTeamID)" :alt="'Team ' + gamedata.AwayTeam.lastgame.HomeTeamID" />
                          </figure>
                        </div>
                        <div v-else class="Previous_matches">
                          <p style="text-align: center; color: #999;">No previous match data</p>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <!-- <template v-else>
                              <tr>
                                  <td colspan="6" class="center-align no-data">No Users Found!</td>
                              </tr>
                          </template> -->
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-tab-item>

        <v-tab-item>
          <div class="stats_table" > 
            <v-simple-table >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>&nbsp;</th>
                    <th>GP</th>
                    <th>Total Points</th>
                    <th>Points</th>
                    <th>3PTA</th>
                    <th>3PT%</th>
                    <th>FGA</th>
                    <th>FG%</th>
                     <th>FTA</th>
                    <th>FT%</th>
                    <th>BLK</th>
                    <th>AST</th>
                    <th>STL</th>
                     <th>Rebounds</th>
                      <th>Fouls</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="gamedata.HomeTeam.stats.length > 0">
                    <tr>
                      <td class="team_logo">
                        <figure class="team_logo" v-if="gamedata.HomeTeam">
                          <img width="30" :src="gamedata.HomeTeam.logo" />
                        </figure>
                      </td>
                      <td v-if="gamedata.HomeTeam.stats.length > 0">{{ gamedata.HomeTeam.stats[0].Games }}</td>
                      <td v-if="gamedata.HomeTeam.stats.length > 0">{{ gamedata.HomeTeam.stats[0].Points }}</td>
                      <td v-if="gamedata.HomeTeam.stats.length > 0">{{ Math.round(gamedata.HomeTeam.stats[0].Points/gamedata.HomeTeam.stats[0].Games) }}</td>
                      <td v-if="gamedata.HomeTeam.stats.length > 0">{{ Math.round(gamedata.HomeTeam.stats[0]["ThreePointersAttempted"]/gamedata.HomeTeam.stats[0].Games) }}</td>

                         <td v-if="gamedata.HomeTeam.stats.length > 0">
                        {{ gamedata.HomeTeam.stats[0]["ThreePointersPercentage"] }}
                      </td>
                                            <td v-if="gamedata.HomeTeam.stats.length > 0">{{ Math.round(gamedata.HomeTeam.stats[0]["FieldGoalsAttempted"]/gamedata.HomeTeam.stats[0].Games) }}</td>

                      <td>
                        {{gamedata.HomeTeam.stats[0]["FieldGoalsPercentage"] }}
                      </td>
                                                                  <td>{{ Math.round(gamedata.HomeTeam.stats[0]["FreeThrowsAttempted"]/gamedata.HomeTeam.stats[0].Games) }}</td>

                      <td>
                        {{ gamedata.HomeTeam.stats[0]["FreeThrowsPercentage"] }}
                      </td>
                    
                      <td>{{ Math.round(gamedata.HomeTeam.stats[0].BlockedShots/gamedata.HomeTeam.stats[0].Games) }}</td>
                      <td>{{ Math.round(gamedata.HomeTeam.stats[0].Assists/gamedata.HomeTeam.stats[0].Games) }}</td>
                      <td>{{ Math.round(gamedata.HomeTeam.stats[0].Steals/gamedata.HomeTeam.stats[0].Games) }}</td>
                      <td>{{ Math.round(gamedata.HomeTeam.stats[0].Rebounds/gamedata.HomeTeam.stats[0].Games) }}</td>
                      <td>{{ Math.round(gamedata.HomeTeam.stats[0].PersonalFouls/gamedata.HomeTeam.stats[0].Games) }}</td>


                   
                    </tr>
                    <tr>
                      <td class="team_logo">
                        <figure class="team_logo" v-if="gamedata.AwayTeam">
                          <img width="30" :src="gamedata.AwayTeam.logo" />
                        </figure>
                      </td>
                           <td>{{ gamedata.AwayTeam.stats[0].Games }}</td>
                      <td>{{ gamedata.AwayTeam.stats[0].Points }}</td>
                      <td>{{ Math.round(gamedata.AwayTeam.stats[0].Points/gamedata.AwayTeam.stats[0].Games) }}</td>
                      <td>{{ Math.round(gamedata.AwayTeam.stats[0]["ThreePointersAttempted"]/gamedata.AwayTeam.stats[0].Games) }}</td>

                         <td>
                        {{ gamedata.AwayTeam.stats[0]["ThreePointersPercentage"] }}
                      </td>
                                            <td>{{ Math.round(gamedata.AwayTeam.stats[0]["FieldGoalsAttempted"]/gamedata.AwayTeam.stats[0].Games) }}</td>

                      <td>
                        {{gamedata.AwayTeam.stats[0]["FieldGoalsPercentage"] }}
                      </td>
                                                                  <td>{{ Math.round(gamedata.AwayTeam.stats[0]["FreeThrowsAttempted"]/gamedata.AwayTeam.stats[0].Games) }}</td>

                      <td>
                        {{ gamedata.AwayTeam.stats[0]["FreeThrowsPercentage"] }}
                      </td>
                    
                      <td>{{ Math.round(gamedata.AwayTeam.stats[0].BlockedShots/gamedata.AwayTeam.stats[0].Games) }}</td>
                      <td>{{ Math.round(gamedata.AwayTeam.stats[0].Assists/gamedata.AwayTeam.stats[0].Games) }}</td>
                      <td>{{ Math.round(gamedata.AwayTeam.stats[0].Steals/gamedata.AwayTeam.stats[0].Games) }}</td>
                      <td>{{ Math.round(gamedata.AwayTeam.stats[0].Rebounds/gamedata.AwayTeam.stats[0].Games) }}</td>
                      <td>{{ Math.round(gamedata.AwayTeam.stats[0].PersonalFouls/gamedata.AwayTeam.stats[0].Games) }}</td>


                    </tr>
                  </template>
                  <!-- <template v-else>
                              <tr>
                                  <td colspan="6" class="center-align no-data">No Users Found!</td>
                              </tr>
                          </template> -->
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-tab-item>

        <v-tab-item>
          <div class="team_lineup_cnt">
            <div class="team_lineup">
              <div class="team_logo">
                <figure class="team_logo">
                  <img width="50" :src="gamedata.HomeTeam.logo" />
                </figure>
              </div>
              <div class="linup_slider">
                <swiper ref="mySwiper" :options="linupslider1">
                  <swiper-slide
                    v-for="(player, index) in gamedata.HomeLineup"
                    :key="index"
                  >
                    <figure>
                      <img
                        :src="
                          siteUrl +
                          '/api/viewfile?path=playerimages/sportsdataio/' +
                          player.PlayerID +
                          '.png'
                        "
                      />
                      <p>
                        {{ player.FirstName }} {{ player.LastName
                        }}<span>{{ player.Position }}</span>
                      </p>
                    </figure>
                  </swiper-slide>
                </swiper>
                <div>
                  <div class="swiper-button-prev prev1">
                    <span class="icon-play-flip"></span>
                  </div>
                  <div class="swiper-button-next next1">
                    <span class="icon-play"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="team_lineup">
              <div class="team_logo">
                <figure class="team_logo">
                  <img width="50" :src="gamedata.AwayTeam.logo" />
                </figure>
              </div>
              <div class="linup_slider">
                <swiper ref="mySwiper" :options="linupslider2">
                  <swiper-slide
                    v-for="(player, index) in gamedata.AwayLineup"
                    :key="index"
                  >
                    <figure>
                      <img
                        :src="
                          siteUrl +
                          '/api/viewfile?path=playerimages/sportsdataio/' +
                          player.PlayerID +
                          '.png'
                        "
                      />
                      <p>
                        {{ player.FirstName }} {{ player.LastName
                        }}<span>{{ player.Position }}</span>
                      </p>
                    </figure>
                  </swiper-slide>
                </swiper>
                <div>
                  <div class="swiper-button-prev prev2">
                    <span class="icon-play-flip"></span>
                  </div>
                  <div class="swiper-button-next next2">
                    <span class="icon-play"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-tab-item>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import teams from "@/data/teams.json";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import moment from "moment";
import { buildTeamLogoUrl } from "@/utils/imageHelpers";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    gamedata: null,
  },
  methods: {
    teamLogoById(teamId) {
      // Handle null/undefined teamId
      if (!teamId) {
        return "";
      }
      // If teamId is already a URL, return it as-is
      if (typeof teamId === 'string' && (teamId.startsWith('http://') || teamId.startsWith('https://'))) {
        return teamId;
      }
      // Try to find team in teams collection for logo fallback
      // teams.json uses TEAM_ID, but backend might provide TeamID or id
      try {
        const team = teams.find(t => 
          t.TeamID === teamId || 
          t.TEAM_ID === teamId || 
          t.id === teamId ||
          String(t.TeamID) === String(teamId) ||
          String(t.TEAM_ID) === String(teamId)
        );
        if (team && team.logo) {
          return team.logo;
        }
      } catch (e) {
        // Fall through to buildTeamLogoUrl
      }
      // Use buildTeamLogoUrl which constructs URL from TeamID
      return buildTeamLogoUrl(teamId);
    },
    gotoIndexdetail(data) {
      this.$router.push({
        name: "probability-details",
        params: { id: data.gameid },
      });
    },
    startElapsedTimer() {
      // Update elapsed time every second
      this.elapsedTimer = setInterval(() => {
        // Force reactivity update
        this.$forceUpdate();
      }, 1000);
    },
  },
  mounted() {
    this.siteUrl = process.env.VUE_APP_API_URL;
    // Start timer for live games
    if (this.gamedata && this.gamedata.Status === 'InProgress') {
      this.startElapsedTimer();
    }
  },
  beforeDestroy() {
    // Clear timer when component is destroyed
    if (this.elapsedTimer) {
      clearInterval(this.elapsedTimer);
    }
  },
  watch: {
    'gamedata.Status'(newStatus) {
      // Start/stop timer based on status
      if (newStatus === 'InProgress' && !this.elapsedTimer) {
        this.startElapsedTimer();
      } else if (newStatus !== 'InProgress' && this.elapsedTimer) {
        clearInterval(this.elapsedTimer);
        this.elapsedTimer = null;
      }
    }
  },
  computed: {
    elapsedTime() {
      // Calculate elapsed time in real-time for InProgress games
      if (this.gamedata && this.gamedata.Status === 'InProgress' && this.gamedata.DateTimeUTC) {
        const gameStartTime = moment.utc(this.gamedata.DateTimeUTC);
        const now = moment.utc();
        const diffSeconds = now.diff(gameStartTime, 'seconds');
        
        if (diffSeconds < 0) {
          return "00:00";
        }
        
        // Format as MM:SS (minutes:seconds)
        const minutes = Math.floor(diffSeconds / 60);
        const seconds = diffSeconds % 60;
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      }
      
      // Fallback to LiveProb.elapsed if available
      if (this.gamedata && this.gamedata.LiveProb && this.gamedata.LiveProb.elapsed) {
        return this.gamedata.LiveProb.elapsed;
      }
      
      return "00:00";
    },
    HomeWinPer(){
      if(this.gamedata.Status == "InProgress" || this.gamedata.Status == "Final"){

        return this.gamedata.LiveProb.home_win_pct
      }
      return this.gamedata.home_win_pct
    },
    AwayWinPer(){
      if(this.gamedata.Status == "InProgress" || this.gamedata.Status == "Final"){

        return this.gamedata.LiveProb.away_win_pct
      }
      return this.gamedata.away_win_pct
    },
    startsIn() {
      // DateTimeUTC is already in UTC format from API, use it directly
      const gameDateTime = this.gamedata.DateTimeUTC || "";
      if (!gameDateTime) {
        return "N/A";
      }
      
      // Ensure it's treated as UTC (add Z if not present)
      const utcDateTime = gameDateTime.endsWith('Z') ? gameDateTime : gameDateTime + 'Z';
      
      if (
        moment
          .utc(utcDateTime)
          .isAfter(moment().utc())
      ) {
        var _t = moment.utc(utcDateTime).diff(moment().utc(), "hours");
        if(_t <= 0){
          _t = moment.utc(utcDateTime).diff(moment().utc(), "minutes");
          return _t +" Minutes"
        }else{
          return _t +" Hours"
        }
      }
      var _z = moment()
        .utc()
        .diff(moment.utc(utcDateTime), "hours");
        if(_z <= 0){
          _z = moment()
        .utc()
        .diff(moment.utc(utcDateTime), "minutes");
          return _z +" Minutes"
        }else{
          return _z +" Hours"
        }
   
    },
    iscompleted() {
      return moment().isBefore(moment(this.gamedatadatee));
    },
    livematch() {
      return (
        moment().isSameOrAfter(moment(this.gamedatadate)) &&
        moment().isSameOrBefore(moment(this.gamedatadatee))
      );
    },
    getHTeamlogo() {
      return this.gamedata.HomeTeam.NbaDotComTeamID;
    },
    getaTeamlogo() {
      return this.gamedata.AwayTeam.NbaDotComTeamID;
    },
  },

  data() {
    return {
      tab: null,
      siteUrl: null,
      elapsedTimer: null,
      linupslider1: {
        slidesPerView: "auto",
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".next1",
          prevEl: ".prev1",
        },
      },
      linupslider2: {
        slidesPerView: "auto",
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".next2",
          prevEl: ".prev2",
        },
      },
    };
  },
};
</script>
